// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.condition-label {
  display: inline-flex;
  align-items: center;
  background: #ffa20070;
  color: black;
  font-weight: 600;
  padding: 1px 6px;
  user-select: none;
  margin-right: 2px;
}

.condition-label--start {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;

  &::before {
    content: '[' attr(data-condition-id);
  }
}

.condition-label--end {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;

  &::before {
    content: attr(data-condition-id) ']';
  }
}
`, "",{"version":3,"sources":["webpack://./shared/domains/pleditor@next/plugins/Conditions/style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;;EAE9B;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;;EAE/B;IACE,oCAAoC;EACtC;AACF","sourcesContent":[".condition-label {\n  display: inline-flex;\n  align-items: center;\n  background: #ffa20070;\n  color: black;\n  font-weight: 600;\n  padding: 1px 6px;\n  user-select: none;\n  margin-right: 2px;\n}\n\n.condition-label--start {\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n\n  &::before {\n    content: '[' attr(data-condition-id);\n  }\n}\n\n.condition-label--end {\n  border-top-right-radius: 3px;\n  border-bottom-right-radius: 3px;\n\n  &::before {\n    content: attr(data-condition-id) ']';\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
